// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file shared/sorting.proto (package gx.shared, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file shared/sorting.proto.
 */
export const file_shared_sorting = /*@__PURE__*/
  fileDesc("ChRzaGFyZWQvc29ydGluZy5wcm90bxIJZ3guc2hhcmVkIl4KDlNvcnRpbmdSZXF1ZXN0EigKCnNvcnRfb3JkZXIYASABKA4yFC5neC5zaGFyZWQuU29ydE9yZGVyEiIKB3NvcnRfYnkYAiABKA4yES5neC5zaGFyZWQuU29ydEJ5KlAKCVNvcnRPcmRlchIaChZTT1JUX09SREVSX1VOU1BFQ0lGSUVEEAASEgoOU09SVF9PUkRFUl9BU0MQARITCg9TT1JUX09SREVSX0RFU0MQAipjCgZTb3J0QnkSFwoTU09SVF9CWV9VTlNQRUNJRklFRBAAEhAKDFNPUlRfQllfTkFNRRABEhYKElNPUlRfQllfQ1JFQVRFRF9BVBACEhYKElNPUlRfQllfVVBEQVRFRF9BVBADQpYBCg1jb20uZ3guc2hhcmVkQgxTb3J0aW5nUHJvdG9QAVoyZ2l0aHViLmNvbS9nYWxheHktaW8vZ3gvc2hhcmVkL2dvL2NvbnRyYWN0cy9zaGFyZWSiAgNHU1iqAglHeC5TaGFyZWTKAglHeFxTaGFyZWTiAhVHeFxTaGFyZWRcR1BCTWV0YWRhdGHqAgpHeDo6U2hhcmVkYgZwcm90bzM");

/**
 * Describes the message gx.shared.SortingRequest.
 * Use `create(SortingRequestSchema)` to create a new message.
 */
export const SortingRequestSchema = /*@__PURE__*/
  messageDesc(file_shared_sorting, 0);

/**
 * Describes the enum gx.shared.SortOrder.
 */
export const SortOrderSchema = /*@__PURE__*/
  enumDesc(file_shared_sorting, 0);

/**
 * @generated from enum gx.shared.SortOrder
 */
export const SortOrder = /*@__PURE__*/
  tsEnum(SortOrderSchema);

/**
 * Describes the enum gx.shared.SortBy.
 */
export const SortBySchema = /*@__PURE__*/
  enumDesc(file_shared_sorting, 1);

/**
 * @generated from enum gx.shared.SortBy
 */
export const SortBy = /*@__PURE__*/
  tsEnum(SortBySchema);

